module.exports = __webpack_public_path__ + "img/fluentright.8fce1dd3.svg";